'use client'

import ErrorState from '@/components/custom/ErrorState'
import { useEffect } from 'react'

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
    useEffect(() => {
        // Log the error to an error reporting service
        console.error(error)
    }, [error])

    return (
        <ErrorState
            error={error}
            reset={reset}
            title='Something went wrong!'
            description='We apologize for the inconvenience. An unexpected error occurred.'
        />
    )
}
